<div class="transaction-details-container">
  <div class="header">
    <span>Enter your domain to discover all SSL certificates and subdomains associated with it via the Certificate Transparency logs.</span>
    <div class="actions">
      <button type="button" class="filter-button secondary-button" (click)="goBack()">
        <i class="fa-solid fa-arrow-left" style="margin-right: 8px;"></i>
        <span>Back to Domains</span>
      </button>
    </div>
  </div>

  <div class="form-container">
    <form (ngSubmit)="submitDomain()" class="domain-form">
      <label for="domain-input" class="form-label">Domain Name</label>
      <div class="domain-input-wrapper">
        <i class="fa-solid fa-globe input-icon"></i>
        <input
          id="domain-input"
          type="text"
          name="domain"
          [(ngModel)]="domain"
          placeholder="e.g. aisslo.com"
          class="domain-input"
          [disabled]="isSubmitting"
          autocomplete="off"
        />
      </div>
      <p class="form-hint">We will scan Certificate Transparency logs to find all known subdomains and SSL certificates for this domain.</p>
      <div class="form-actions">
        <button type="submit" class="filter-button submit-button" [disabled]="isSubmitting">
          <i class="fa-solid fa-magnifying-glass" style="margin-right: 8px;" *ngIf="!isSubmitting"></i>
          <i class="fa-solid fa-spinner fa-spin" style="margin-right: 8px;" *ngIf="isSubmitting"></i>
          {{ isSubmitting ? 'Searching...' : 'Search Domain' }}
        </button>
      </div>
    </form>
  </div>
</div>
